<kendo-splitter class="padding">

    <kendo-splitter-pane class="style-splitter" size="55%">
        <!-- <kendo-label class="label" text="Companies"></kendo-label> -->
        <!-- <div class="search-box" style="height: 8%; margin-bottom: 15px;">

            <kendo-textbox [(value)]="searchTerm" [style.width.px]="338" [clearButton]="true"
                placeholder="Search on Email, First or Last Name"
                (valueChange)="onFilter($event)"></kendo-textbox>&nbsp;&nbsp;

        </div> -->
        <div style="height:100%;">
            <kendo-grid #grid class="k-grid k-grid-header custom2" style="height:100%;"
                [kendoGridBinding]="displayUsers" kendoGridSelectBy="email" [(selectedKeys)]="selection"
                [selectable]="{ mode: 'single'}" [loading]="usersLoading" [sortable]="true" [size]="smallSize"
                [resizable]="true" (cellClick)="onCellClick($event)" scrollable="virtual" [pageSize]="pageSize"
                [filterable]="false" [rowHeight]="32" [rowClass]="rowCallback" (excelExport)="exportAll($event)">
                <ng-template kendoGridToolbarTemplate>
                    <input type="text" class="kendo-like-input" placeholder="Search in Name, Description or Company"
                        [(ngModel)]="searchTerm" [ngModelOptions]="{ standalone: true }"
                        (ngModelChange)="onFilter($event)" kendoGridToolbarFocusable />
                    <kendo-grid-spacer></kendo-grid-spacer>

                    <button kendoGridExcelCommand class="allbuttons" [svgIcon]="excelSVG">
                        Export
                    </button>
                </ng-template>
                <kendo-grid-column field="id" title="ID" [width]="40"></kendo-grid-column>
                <kendo-grid-column field="email" title="Email" [width]="200"></kendo-grid-column>
                <kendo-grid-column field="firstname" title="First Name" [width]="100"></kendo-grid-column>
                <kendo-grid-column field="lastname" title="Last Name" [width]="100"></kendo-grid-column>
                <kendo-grid-column field="companyName" title="Company Name" [width]="120"></kendo-grid-column>
                <kendo-grid-excel [fileName]="getFileName()"></kendo-grid-excel>
                <!-- <kendo-grid-column field="usertype" title="User Type" [width]="10"></kendo-grid-column>
                <kendo-grid-column field="companyId" title="Company ID" [width]="10"></kendo-grid-column> -->
                <kendo-grid-column title="Access Details" [width]="150">

                    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                        <span>
                            <button kendoButton class="allbuttons k-button k-button-icontext"
                                (click)="showAccessDetails($event, dataItem, rowIndex)" style="margin-right: 3px"
                                title="Access Details">
                                <!--<span class="k-icon k-i-accessibility"></span>-->

                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                    viewBox="0 0 24 24" style="vertical-align: middle;">
                                    <path
                                        d="M10.18 9.72a5.5 5.5 0 1 1 1.41 1.41l-2.3 2.3H7v2H5v2H2v-3.59l8.18-8.18zM18.5 8a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z" />
                                </svg>


                            </button>
                        </span>
                    </ng-template>
                </kendo-grid-column>

            </kendo-grid>
        </div>
    </kendo-splitter-pane>
    <kendo-splitter-pane>

        <!-- <form class="k-form k-form-md" [formGroup]="companyform"> -->
        <form class="k-form k-form-md" [formGroup]="form">
            <div>
                <button class="adminbutton allbuttons" kendoButton (click)="onAddButtonClick()"
                    [disabled]="addbuttonstate" [hidden]="buttonshidden">
                    <div style="display: flex;">
                        <kendo-svg-icon [icon]="iconNames[0]" style="margin-right: 1px;margin-top: 2px"
                            size="medium"></kendo-svg-icon>
                        <div>Add</div>
                    </div>
                </button>
                <button class="adminbutton allbuttons" style="margin-left: 10px;" kendoButton
                    (click)="onRemoveButtonClick()" [disabled]="removebuttonstate" [hidden]="buttonshidden">
                    <div style="display: flex;">
                        <kendo-svg-icon [icon]="iconNames[1]" style="margin-right: 1px;margin-top: 2px"
                            size="medium"></kendo-svg-icon>
                        <div>Remove</div>
                    </div>
                </button>
                <button class="adminbutton allbuttons" style="margin-left: 10px;" kendoButton
                    (click)="onSaveButtonClick()" [disabled]="savebuttonstate || !mailCheck" [hidden]="buttonshidden">
                    <div style="display: flex;">
                        <kendo-svg-icon [icon]="iconNames[2]" style="margin-right: 2px;margin-top: 2px"
                            size="medium"></kendo-svg-icon>
                        <div>Save</div>
                    </div>
                </button>
                <!-- style="position: absolute; right: 0; margin-right: 220px;" -->
                <button class="adminbutton allbuttons" kendoButton (click)="onExcelClick()"
                    [disabled]="uploadbuttonstate" [hidden]="buttonshidden" style="margin-left: 10px;">
                    <div style="display: flex;">
                        <kendo-svg-icon [icon]="iconNames[3]" style="margin-right: 2px;margin-top: 2px"
                            size="medium"></kendo-svg-icon>
                        <div>Upload</div>
                    </div>
                </button>

            </div>

            <div class="wrap1">
                <div class="wrap">
                    <kendo-formfield>
                        <kendo-label class="label" #id id="id" [for]="id" text="ID"></kendo-label>
                        <kendo-textbox [style.width.px]="90" class="readonly" formControlName="id"
                            [readonly]="true"></kendo-textbox>
                    </kendo-formfield>
                    <kendo-formfield>
                        <kendo-checkbox style="margin-left:20px;" #enabled formControlName="enabled"
                            (change)="UserEnabledChange($event)"></kendo-checkbox>
                        <kendo-label class="label" [for]="enabled" text="Enabled"></kendo-label>



                    </kendo-formfield>
                </div>
                <div class="wrap">
                    <kendo-formfield>
                        <kendo-label class="label" #firstname id="firstname" [for]="firstname"
                            text="First Name"></kendo-label>
                        <kendo-textbox [style.width.px]="180" #firstnametext class="class-id"
                            formControlName="firstname" [readonly]="readonly"
                            (valueChange)="valueChange($event,'firstname')"></kendo-textbox>
                    </kendo-formfield>
                    <kendo-formfield>
                        <kendo-label class="label" #lastname id="lastname" [for]="lastname"
                            text="Last Name"></kendo-label>
                        <kendo-textbox [style.width.px]="180" class="class-id" formControlName="lastname"
                            [readonly]="readonly" (valueChange)="valueChange($event,'lastname')"></kendo-textbox>
                    </kendo-formfield>
                </div>
                <kendo-formfield>
                    <kendo-label type="email" class="label" #email id="email" [for]="email" text="Email"></kendo-label>
                    <kendo-textbox [style.width.px]="400" class="class-id" formControlName="email" [readonly]="readonly"
                        (valueChange)="valueChange($event,'email')"></kendo-textbox>
                </kendo-formfield>
                <div class="wrap">
                    <kendo-formfield>
                        <kendo-label class="label" #usertype id="usertype" [for]="usertype"
                            text="User Type"></kendo-label>
                        <kendo-dropdownlist #usertypes [data]="listItems" textField="text" valueField="value"
                            formControlName="usertype" [value]="selectedItem" (valueChange)="usertypeChange($event)"
                            [style.width.px]="180">
                        </kendo-dropdownlist>
                    </kendo-formfield>
                </div>
                <kendo-formfield>
                    <kendo-label class="label" #company id="company" [for]="company" text="Company"></kendo-label>
                    <kendo-dropdownlist #company [data]="companiesItems" textField="text" valueField="value"
                        formControlName="company" [value]="selectedCompanyItem" (valueChange)="companyChange($event)"
                        [style.width.px]="300">
                    </kendo-dropdownlist>
                </kendo-formfield>


                <div class="wrap">
                    <kendo-formfield>
                        <kendo-label class="label" #created id="created" [for]="created" text="Created"></kendo-label>
                        <!-- <kendo-textbox [style.width.px]="180" class="readonly" formControlName="created"
                            [readonly]="true"></kendo-textbox> -->
                        <input kendoTextBox [value]="(form.get('created')?.value | date: 'dd-MMM-yyyy') || ''"
                            style="width: 180px;" class="readonly k-readonly" readonly>
                    </kendo-formfield>
                    <kendo-formfield>
                        <kendo-label class="label" #createdBy id="createdBy" [for]="createdBy"
                            text="Created By"></kendo-label>
                        <kendo-textbox [style.width.px]="180" class="readonly" formControlName="createdBy"
                            [readonly]="true"></kendo-textbox>
                    </kendo-formfield>
                    <!-- <div>
                        <kendo-formfield>
                            <kendo-label class="label" #zip id="zip" [for]="zip" text="ZIP"></kendo-label>
                            <kendo-textbox [style.width.px]="170" class="class-id" formControlName="zip"
                                [readonly]="readonly" (valueChange)="valueChange($event)"></kendo-textbox>
                        </kendo-formfield>
                    </div> -->
                </div>
                <kendo-formfield>
                    <kendo-label class="label" #remarks id="remarks" [for]="remarks" text="Remarks"></kendo-label>
                    <kendo-textarea [style.width.px]="400" formControlName="remarks" [readonly]="readonly"
                        (valueChange)="valueChange($event,'remarks')" [rows]="2" resizable="vertical"></kendo-textarea>
                </kendo-formfield>
                <!-- <div class="wrap">
                    <kendo-formfield>
                        <kendo-label class="label" #phone id="phone" [for]="phone" text="Phone"></kendo-label>
                        <kendo-textbox [style.width.px]="200" class="class-id" formControlName="phone"
                            [readonly]="readonly" (valueChange)="valueChange($event)"></kendo-textbox>
                    </kendo-formfield>
                    <kendo-formfield>
                        <kendo-label class="label" #recipientCode id="recipientCode" [for]="phone"
                            text="Recipient Code"></kendo-label>
                        <kendo-textbox [style.width.px]="170" class="class-id" formControlName="recipientCode"
                            [readonly]="readonly" (valueChange)="valueChange($event)"></kendo-textbox>
                    </kendo-formfield>
                </div> -->
            </div>



            <!--  <kendo-formfield>
                <kendo-label [for]="attributename" text="Attribute Name"></kendo-label>
                <kendo-textbox formControlName="attributename" #attributename [style.width.px]="400" id="attributename"
                    [readonly]="readonly" [minlength]="4" [maxlength]="50"  (valueChange)="onValueChange($event,'attributename')"></kendo-textbox>
                <kendo-formerror>Error: Attribute Name is required (minimum length is 4)</kendo-formerror>
            </kendo-formfield> -->
        </form>
    </kendo-splitter-pane>

</kendo-splitter>

<div>
    <kendo-window title={{windowTitle}} *ngIf="openedexcelwindow" (close)="closeExcelWindow()" [width]="800"
        [height]="400" [resizable]="false" [top]="0" [left]="30">
        <br>
        <div id="spreadsheet">
            <kendo-spreadsheet [sheets]="exceldata" #spreadsheet style="height: 250px; width: 100%" [rowHeight]="20"
            (excelImport)="onImport($event)"    
            [headerHeight]="10" [columns]="3" [menuItems]="items" (excelExport)="onExcelExport($event)">
            </kendo-spreadsheet>
        </div>
        <div class="k-actions k-actions-end">
            <button kendoButton type="button" (click)="closeExcelWindow()">Cancel</button>
            <button kendoButton type="button" (click)="saveExcelSample(spreadsheet)">Validate</button>
        </div>
        <span class="blue" style="font-size: small;font-style: italic;text-align: left;"> *All fields are mandatory
            except for remarks which should have a dash '-' for nothing</span>
        <div class="k-dialog-content">
            <ng-container kendoDialogContainer></ng-container>
        </div>
    </kendo-window>

</div>

<kendo-window *ngIf="showWindow" [title]="'Access Details for ' + selectedUser.firstname + ' ' + selectedUser.lastname"
    [width]="600" [top]="windowTop" [left]="windowLeft" [draggable]="true" [resizable]="true" (close)="closeWindow()"
    style="max-height: 80vh; overflow: auto;">
    <div class="window-content">

        <div *ngIf="loadingAccessDetails" style="text-align: center; padding: 20px;">
            <div class="spinner"></div>
            <p>Loading access details...</p>
        </div>

        <ng-container *ngIf="!loadingAccessDetails">
            <div style="text-align: right; margin-bottom: 10px;">
                <button kendoButton class="allbuttons" [svgIcon]="iconNames[0]" (click)="expandAll()">
                    Expand All
                </button>
                <button kendoButton class="allbuttons" [svgIcon]="iconNames[9]" (click)="collapseAll()">
                    Collapse All
                </button>
            </div>

            <div *ngFor="let access of userAccessDetailsList; let i = index"
                style="border: 1px solid #ccc; border-radius: 5px; padding: 10px; margin-bottom: 10px;">

                <div (click)="togglePanel(i)"
                    style="cursor: pointer; font-weight: bold; display: flex; justify-content: space-between;">
                    {{ access.projectName }}
                    <span>{{ expandedPanels.has(i) ? '▲' : '▼' }}</span>
                </div>

                <div *ngIf="expandedPanels.has(i)" style="margin-top: 10px;">

                    <table class="k-table" style="width: 100%; border-collapse: collapse;">
                        <thead>
                            <tr>
                                <th class="fixed-col order-col">Order</th>
                                <th class="fixed-col order-col">Role</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let portalAccess of access.orderList">
                                <tr *ngFor="let order of getOrderList(portalAccess)">
                                    <td class="fixed-col order-col">{{ order.name }}</td>
                                    <td class="fixed-col order-col">{{ order.access }}
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>

                </div>
            </div>
        </ng-container>
    </div>
</kendo-window>
<kendo-window [title]="title" *ngIf="errorWindow" [width]="500" [height]="250" [top]="20" [draggable]="true"
    [resizable]="true" (close)="errorWindow = false">
    <div class="error-dialog-content">
        <div class="error-text-container">
            <pre class="error-text-block">{{ content }}</pre>
        </div>
        <kendo-dialog-actions>
            <button kendoButton style="height: 30px;background-color: #1825aa;color: white"
                (click)="copyToClipboard();success('Ready to paste in Excel')">Copy for Excel</button>
            <button kendoButton style="height: 30px;background-color: #1825aa;color: white"
                (click)="errorWindow = false">Cancel</button>
        </kendo-dialog-actions>
    </div>
</kendo-window>